import { useState, useEffect } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { useUser } from "./useUser";

export const useAuth = () => {

	const { addUser, removeUser, user, token, role, userId, mustChangePassword, updateMustChangePassword, isEspecial, userMunicipio, entidadId } = useUser(); //prueba
	console.log("user en useAuth.js", user)
	console.log("role en useAuth.js", role)
	console.log("userId en useAuth.js", userId)

	const [isAuthenticated, setIsAuthenticated] = useState(false);
	console.log(isAuthenticated)

	useEffect(() => {
		if (user) {
			setIsAuthenticated(true);
		} else {
			setIsAuthenticated(false);
		}
	}, [user]);

	// login
	const login = (name, token, role, userId, mustChangePass = false, isEspecialFlag = false, userMunicipioVal = null, entidadIdVal = null) => {
		/* NOTE: this is where you would query the user from 
		  an auth provider like firebase, supabase or Auth0 
		  and retrieve the user object. Additionally you 
		  could do your own auth, but that is not recommended
	    
		  So What we'll do for now is set a mock user object.
		*/
		console.log('🔐 useAuth.login - userMunicipioVal:', userMunicipioVal, 'entidadIdVal:', entidadIdVal);
		addUser(name, token, role, userId, mustChangePass, isEspecialFlag, userMunicipioVal, entidadIdVal);
	};

	const logout = () => {
		removeUser();
		// Limpiar datos del formulario RED al cerrar sesión
		localStorage.removeItem('red_form_draft');
		localStorage.removeItem('estadoAppX');
		localStorage.removeItem('redFormData');
		// Disparar evento para que RedContext limpie su estado
		window.dispatchEvent(new Event('red-logout'));
	};

	return { user, login, logout, isAuthenticated, role, userId, token, mustChangePassword, updateMustChangePassword, isEspecial, userMunicipio, entidadId };
};